import React from 'react'
import Link from 'gatsby-link'
import {
  Divider,
  Container,
  Grid,
  Segment,
  Button,
  Icon,
  Responsive,
  Step,
} from 'semantic-ui-react'
import Productcard from '../components/productcard'
import Productfilters from '../components/productfilters'
import Helmet from 'react-helmet'

const IndexPage = ({ data }) => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
    <Helmet>
      <title>
        Find Growth Tools | The Best SaaS Tools To Help Startups Grow
      </title>
      <meta
        name="description"
        content="A curated list of the best SaaS tools to help your company grow. Discover growth tools by category, growth lever, integration and more."
      />
      <meta
        property="og:image"
        content="https://images.ctfassets.net/wmadclbhjs1z/2JSsQivOtuWeORWiNBKKzg/005487471f4b465c1b3bca7d657e67a4/opengraph.png"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@findgrowthtools" />
      <meta
        name="twitter:title"
        content="Find Growth Tools | The Best SaaS Tools To Help Startups Grow"
      />

      <meta
        name="twitter:image"
        content="https://images.ctfassets.net/wmadclbhjs1z/2JSsQivOtuWeORWiNBKKzg/005487471f4b465c1b3bca7d657e67a4/opengraph.png"
      />
    </Helmet>

    <Responsive minWidth={770}>
      <Segment basic>
        <Grid columns={2}>
          <Grid.Column textAlign="center">
            <Segment basic>
              <h1
                style={{
                  fontSize: '3.25rem',
                  color: 'white',
                }}
              >
                Find the best{' '}
                <span
                  style={{
                    color: '#39e7ce',
                    // fontFamily: 'OpenSans-ExtraBold',
                      fontFamily: 'Open Sans',
                fontWeight: '800',
                    letterSpacing: '-1.5px',
                  }}
                >
                  SaaS tools
                </span>{' '}
                to help your company grow.
              </h1>
            </Segment>
          </Grid.Column>
          <Grid.Column verticalAlign="middle">
            <Segment
              basic
              compact
              textAlign="center"
              style={{ maxWidth: 1260, margin: '0 auto' }}
            >
              <h3 style={{ color: '#FFF' }}>Find growth tools by</h3>

              <div>
                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/categories/"
                >
                  Category
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/growthlevers/"
                >
                  Growth Lever
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/integrations/"
                >
                  Integration
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/customers/"
                >
                  Customer
                </Button>
              </div>
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    </Responsive>

    <Responsive maxWidth={769}>
      <Segment basic>
        <Grid>
          <Grid.Column textAlign="center">
            <Segment basic>
              <h1
                style={{
                  fontSize: '1.5rem',
                  color: 'white',
                }}
              >
                Find the best <span style={{ color: '#39e7ce',      color: '#39e7ce',
                    // fontFamily: 'OpenSans-ExtraBold',
                    fontFamily: 'Open Sans',
                    fontWeight: '800',
                    letterSpacing: '-1.5px', }}>SaaS tools</span>{' '}
                 to help your company grow.
              </h1>
            </Segment>
            <Segment
              basic
              compact
              textAlign="center"
              style={{ maxWidth: 1260, margin: '0 auto' }}
            >
              <h3 style={{ color: '#FFF' }}>Find growth tools by</h3>

              <div>
                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/categories/"
                >
                  Category
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/growthlevers/"
                >
                  Growth Lever
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/integrations/"
                >
                  Integration
                </Button>

                <Button
                  style={{ marginBottom: '10px' }}
                  compact
                  size="small"
                  href="/customers/"
                >
                  Customer
                </Button>
              </div>
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    </Responsive>

    <br />
    <br />
    <Grid textAlign="center">
      {/* Map array of products to display as a list */}
      {data.allContentfulProduct.edges.map(({ node }) => (
        <div key={node.id}>
          <Productcard key={node.id} node={node} />
          <Divider hidden />
        </div>
      ))}
    </Grid>

    <Segment
      basic
      compact
      textAlign="center"
      style={{ maxWidth: 1260, margin: '0 auto' }}
    >
      <h4>Still looking? Narrow your search:</h4>

      <Button
        style={{ marginBottom: '10px' }}
        compact
        size="small"
        href="/categories/"
      >
        Category
      </Button>
      <Button
        style={{ marginBottom: '10px' }}
        compact
        size="small"
        href="/growthlevers/"
      >
        Growth Lever
      </Button>
      <Button
        style={{ marginBottom: '10px' }}
        compact
        size="small"
        href="/integrations/"
      >
        Integration
      </Button>
      <Button
        style={{ marginBottom: '10px' }}
        compact
        size="small"
        href="/customers/"
      >
        Customer
      </Button>
    </Segment>

    {/* <Productcard /> */}

    <Divider size="large" hidden />

    <Divider hidden />
  </div>
)

export default IndexPage

export const query = graphql`
  query IndexQuery {
    allContentfulProduct(
      limit: 10
      sort: { fields: [createdAt], order: DESC }
    ) {
      edges {
        node {
          id
          slug
          name
          website
          primaryCategories {
            id
            name
            slug
          }
          subCategories {
            id
            name
          }
          growthLever {
            id
            name
          }
          customerSector {
            id
            name
          }
          customerBudget {
            id
            name
          }
          screenshots {
            id
            title
            resolutions(width: 265) {
              ...GatsbyContentfulResolutions
            }
            file {
              url
            }
          }
          shortDescription
          freeTrialAvailable
          freePlan
          startingPrice
          pricingNote
          developerRequired
          customersList {
            name
            id
          }
          integratesWith {
            id
            name
          }
          createdAt(formatString: "MMMM Do, YYYY")
          updatedAt(formatString: "MMMM Do, YYYY")
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js